var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHomeplanBoiler = function SvgHomeplanBoiler(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 32H11V42H37V32Z",
    fill: "#0D8426"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11 6V32H37V6H11ZM31 28H17V20H31V28Z",
    fill: "#0D8426"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 26C22.1046 26 23 25.1046 23 24C23 22.8954 22.1046 22 21 22C19.8954 22 19 22.8954 19 24C19 25.1046 19.8954 26 21 26Z",
    fill: "#0D8426"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 26C28.1046 26 29 25.1046 29 24C29 22.8954 28.1046 22 27 22C25.8954 22 25 22.8954 25 24C25 25.1046 25.8954 26 27 26Z",
    fill: "#0D8426"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHomeplanBoiler);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "homeplan-boiler.9596cff27dcbc8b84dabb5b33a7fc1cc.svg";